




































































































































































































import _ from 'lodash';
import { dropdownListProvider } from '@/main/dropdownApi';
import { MessageBoxCloseAction } from 'element-ui/types/message-box';

import { editName } from '@/main/store/listEditTypes';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { editFactory } from '@/main/pages/editFactory';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { apiProvider } from './api';
import { store } from './store/edit';
import { AuthPracovnikInterface, ScopeDropdownItem, ScopeValueTypes, types } from './store/types';
import { NAME, TAB_NAMES, TABS } from './constants';
import Provozovny from './components/Provozovny.vue';

export default editFactory(NAME, store).extend({
	name: editName(NAME),
	components: {
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		Provozovny,
	},
	data() {
		return {
			externalInput: [] as string[],
			tabNames: TAB_NAMES,
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(NAME, TABS.BasicInfo)) tabItems.push(TAB_NAMES.BASICINFO);
			if (this.hasTabAccess(NAME, TABS.LoginSettings)) tabItems.push(TAB_NAMES.LOGINSETTINGS);

			return _.pick(TABS, tabItems);
		},
		mutationsMappers() {
			return {
				nakladoveStredisko: `${this.storeUri}/${types.mutations.PRACOVNIK_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		addScopeDisabledConditions() {
			return this.Auths.length === this.dropdownList.Scopes.length || this.isCreateMode;
		},
		allowDelete(): boolean {
			return false;
		},
	},
	methods: {
		async saveClick() {
			if (await this.checkUniquePersonalId()) {
				return;
			}

			await this.save();
		},
		async checkUniquePersonalId(): Promise<boolean> {
			if ((await apiProvider.isUniquePersonalId(this.PracovnikId, this.OsobniCis)).data) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: `${this.LocalizeChyboveHlasky('InvalidWorkerPersonalId')}`,
					options: { type: 'error' },
				});
				return true;
			}
			return false;
		},
	 	getColumnLabel(columnName:any) {
			return `${'* '}${this.Localize(columnName)}`;
		},

		async workshopChange(value: any) {
			if (value) {
				this.startLoading();
				const { data } = await apiProvider.getTeamWorkers(value);
				this.dropdownList.TympracId = data;
				this.endLoading();
			}
		},
		loadedData() {
			this.externalInput = _.map(this.Auths, (auth) => (
				auth.ScopeValueType === ScopeValueTypes.EMAIL ? auth.ScopeValue : ''
			));
		},
		authOptionsFilterFunc(data: DropdownItem) {
			return !this.Auths.map((auth) => auth.Scope).includes(data.Text);
		},
		isInputPassword(auth: AuthPracovnikInterface): boolean {
			return auth.ScopeValueType === ScopeValueTypes.PASSWORD;
		},
		isScopeValue(value: string): boolean {
			return !_.isEmpty(value);
		},
		isEmailValid(idx: number): boolean {
			const emailRegExp = new RegExp('^[_a-zA-Z0-9-]+(\\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+$');
			return emailRegExp.test(this.externalInput[idx]);
		},
		addScope() {
			this.Auths = [
				..._.defaultTo(this.Auths, []),
				{
					Active: false,
					PracovnikId: this.edit.PracovnikId!,
					Scope: '',
					ScopeValue: '',
					ScopeValueType: null,
				},
			];
		},
		updateScopeSelect(scope: string, idx: number) {
			const auth = _.find(this.dropdownList.Scopes, (item: ScopeDropdownItem) => String(item.Value) === scope);
			if (auth) this.Auths[idx].ScopeValueType = auth.ValueType;
			this.Auths[idx].Scope = scope;
			this.externalInput[idx] = '';
		},
		scopeActivationConfirm(isActive: boolean, pracovnikAuth: AuthPracovnikInterface, idx: number) {
			this.showConfirm({
				message: this.LocalizeChyboveHlasky('changeScopeActiveStatus'),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					cancelButtonText: this.Localize('Ne'),
					confirmButtonText: this.Localize('Ano'),
					callback: (action: MessageBoxCloseAction) => {
						if (action === 'confirm') {
							this.scopeActivation(pracovnikAuth);
						} else {
							this.Auths[idx].Active = !isActive;
						}
					},
				},
			});
		},
		async scopeActivation(pracovnikAuth: AuthPracovnikInterface) {
			try {
				const { PracovnikId, Active, Scope } = pracovnikAuth;
				await apiProvider.passwordStatusSwitch({ PracovnikId, Active, Scope });
				await this.showNotification({
					title: this.Localize('DMS3_SuccessTitle'),
					message: this.LocalizeChyboveHlasky('SaveOK'),
					type: 'success',
				});
			} catch (err) {
				this.logError(err);
			} finally {
				this.refreshPage();
			}
		},
		resetPasswordConfirm(pracovnikAuth: AuthPracovnikInterface, idx: number) {
			if (!this.isInputPassword(pracovnikAuth) && !this.isEmailValid(idx)) {
				this.showNotification({
					title: this.Localize('DMS3_WarningTitle'),
					message: this.LocalizeChyboveHlasky('EmailNotValid'),
					type: 'warning',
				});
				return;
			}
			this.showConfirm({
				message: this.LocalizeChyboveHlasky(
					this.isInputPassword(pracovnikAuth)
						? 'resetScopePasswordConfirm'
						: 'setScopeEmailConfirm',
				),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					cancelButtonText: this.Localize('Ne'),
					confirmButtonText: this.Localize('Ano'),
					callback: async (action: MessageBoxCloseAction) => {
						if (action === 'confirm') {
							this.resetPassword(pracovnikAuth, idx);
						}
					},
				},
			});
		},
		async resetPassword(pracovnikAuth: AuthPracovnikInterface, idx: number) {
			try {
				const { PracovnikId, Scope } = pracovnikAuth;
				await apiProvider.resetScopePassword({
					PracovnikId,
					Password: this.externalInput[idx],
					Scope,
				});
				await this.showNotification({
					title: this.Localize('DMS3_SuccessTitle'),
					message: this.LocalizeChyboveHlasky('SaveOK'),
					type: 'success',
				});
			} catch (err) {
				this.logError(err);
			} finally {
				this.refreshPage();
				if (this.isInputPassword(pracovnikAuth)) {
					this.externalInput[idx] = '';
				}
			}
		},
	},
});
